<template>
    <DatePicker @on-ok="confirm" @on-clear="clear" v-model="SelectedDate" type="daterange" format="yyyy年MM月dd日"
                :options="options" confirm split-panels placeholder="选择时间" style="width: 250px"></DatePicker>
</template>
<script>
    export default {
        data() {
            return {
                SelectedDate: null,
                options: {
                    shortcuts: [
                        {
                            text: '今天',
                            value() {
                                const end = new Date();
                                return [end, end];
                            }
                        },
                        {
                            text: '昨天',
                            value() {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (2 - 1));
                                return [start, start];
                            }
                        },
                        {
                            text: '7 天',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - 1));
                                return [start, end];
                            }
                        },
                        {
                            text: '14 天',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (14 - 1));
                                return [start, end];
                            }
                        },
                        {
                            text: '30 天',
                            value() {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * (30 - 1));
                                return [start, end];
                            }
                        }
                    ]
                }
            }
        },
        created(){
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 - 1));
            this.SelectedDate = [start,end]
        },
        methods: {
            confirm() {
                if (this.SelectedDate[0] === ""){
                    alert('请选择时间范围');
                    return
                }
                this.$emit("transmit", this.SelectedDate)
            },
            clear() {
                this.SelectedDate = null;
            }
        }
    }
</script>

<style scoped>

</style>